var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 131,
    viewBox: "0 0 135 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button play"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 131,
    rx: 65.5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Play",
    d: "M57.1504 41.3105C55.1625 39.9135 52.4254 41.3354 52.4254 43.765V91.165C52.4254 93.5946 55.1625 95.0165 57.1504 93.6195L90.8745 69.9195C92.5746 68.7247 92.5746 66.2052 90.8745 65.0105L57.1504 41.3105Z",
    fill: "#939393"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlay);
export default __webpack_public_path__ + "static/media/Button-play.ac6ebce8278ba2807b0912b6da4f876f.svg";
export { ForwardRef as ReactComponent };